import React, {Component} from "react";
import {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';
import useFetch from '../APIs/FetchSongs.js';
import LoadingSkeleton from '../LoadingSkeletons/card005.js';
import TrackCard from '../Cards/card005.js'

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// import required modules
import { Navigation } from "swiper/modules";
const Songs = (props) => {
    
    //userId,songId,search_string,genre,sort,page,
    
    const [data, setData] = useState(null);
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    useEffect(()=>{
        if(FetchedData){
            setData(FetchedData)
        }
    },[FetchedData])


    const send_request =()=>{
        setData(null)
        setRequest({
            "user_id":props.user_id,
            "song_id":"",
            "search_string":"",
            "genre":"",
            "sort":"played",
            "type":"",
            "page":"",
        })
    }



    useEffect(()=>{
        send_request()
    },[])

   
    return (
        <>
            {data &&(
                <>
                    <div className="htitle">
                        <div className="lft"><p>Popular </p></div>
                        {data.results.length > 3 &&(
                            <div className="rgt"><p><Link to={"/profile/browse/"+props.user_id+"?group=songs&sort=played"}>See more</Link></p></div>
                        )}
                    </div>
                  
                    {data.results.slice(0,3).map((song,index)=>{
                            return <TrackCard key={index} data={song} Data={data.results} index={index}/>
                        }
                    )}
                </>
            )}
            {isLoading &&(
                <>
                    <div className="htitle">
                        <div className="lft"><p>SINGLES</p></div>
                    </div>
                    
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                    <LoadingSkeleton/>
                   
                </>
            )}
        </>
    )
}

export default Songs
